// src/utils/ferdigDatoVisning.js
// Ønsket ferdigdato for ski-/skøytebestillinger (frontend-motstykket til
// src/lib/onsketFerdigDato.js). Produkter med `ferdigDatoValgfri` har kun
// lovet kunden `onsketFerdigDato`; `forventetFerdigDato` er verkstedets
// interne mål. Eldre bookinger og sykkel har ikke merket og vises som før.

export const IKKE_SATT = "Dato ikke satt";

function isoDag(value) {
  if (!value) return "";
  const s = String(value);
  if (/^\d{4}-\d{2}-\d{2}/.test(s)) return s.slice(0, 10);
  const d = new Date(value);
  return isNaN(d.getTime()) ? "" : d.toISOString().slice(0, 10);
}

export function onsketFerdigTekst(prod, fmt) {
  return prod?.onsketFerdigDato ? fmt(prod.onsketFerdigDato) : IKKE_SATT;
}

// Ønsket dato før beregnet dato — lov for ansatte, men gir advarsel.
export function erForTidligOnsket(onsket, forventet) {
  const o = isoDag(onsket);
  const f = isoDag(forventet);
  return !!o && !!f && o < f;
}

// Datoen verkstedet faktisk må holde: ønsket dato hvis satt, ellers beregnet.
export function fristDato(prod) {
  return (prod?.ferdigDatoValgfri && prod?.onsketFerdigDato) || prod?.forventetFerdigDato || null;
}

// Linje til kunden. Returnerer { label, tekst } eller null.
export function kundeFerdigLinje(prod, fmt, standardLabel) {
  if (prod?.ferdigDatoValgfri) {
    return prod.onsketFerdigDato
      ? { label: "Ønsket ferdig", tekst: fmt(prod.onsketFerdigDato) }
      : { label: "Ferdigdato", tekst: IKKE_SATT };
  }
  return prod?.forventetFerdigDato
    ? { label: standardLabel, tekst: fmt(prod.forventetFerdigDato) }
    : null;
}
